import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useService } from '../providers/ServiceProvider';
import { Dependency } from '@analyzer/client';

export function useDependencyListQuery(
  projectId: string,
  testId: string,
  queryParams?: { limit?: number; offset?: number }
) {
  const client = useService();
  return useQuery<Dependency[], Error>(
    ['dependency-list', projectId, testId, queryParams],
    () => client.dependencyList(projectId, testId, queryParams),
    {
      keepPreviousData: true
    }
  );
}

export function useDependencyReadQuery(projectId: string, dependencyId: string) {
  const client = useService();
  return useQuery<Dependency, Error>({
    queryKey: ['dependency-read', projectId],
    queryFn: () => client.dependencyRead(projectId, dependencyId)
  });
}

export function useDependencyDestroyMutation(projectId: string, testId: string) {
  const client = useService();
  const queryClient = useQueryClient();

  return useMutation<boolean, Error, { dependencyId: string }>({
    mutationFn: ({ dependencyId }) => client.dependencyDestroy(projectId, dependencyId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['dependency-list', projectId, testId] })
  });
}
